/**
 * 実行日の0時0分0秒のDateを取得する関数
 * @returns 実行日の0時0分0秒のDate
 */
export const getToday: () => Date = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

/**
 * 翌日の0時0分0秒のDateを取得する関数
 * @returns 翌日の0時0分0秒のDate
 */
export const getTomorrow: () => Date = () => {
  const date = new Date();
  date.setDate(date.getDate() + 1);
  date.setHours(0, 0, 0, 0);
  return date;
};

/**
 * 日付の大小比較をする関数
 * @returns fromの方がtoより前の日付ならtrue
 *          fromの方がtoの以後の日付ならfalse
 */
export const isFromBeforeTo = (from: Date | undefined, to: Date | undefined): boolean => {
  if (from == null || to == null) return true;
  if (from >= to) return false;
  return true;
};

/**
 * fromとtoの間がday日以内かどうかを判定する関数
 * @returns fromとtoの間がday日以内ならtrue
 *          fromとtoの間がday日より離れてるならfalse
 */
export const isWithinDays = (from: Date, to: Date, days: number): boolean => {
  // 日数が欲しいので時分秒は0にする
  const day1 = new Date(from);
  day1.setHours(0, 0, 0, 0);
  const day2 = new Date(to);
  day2.setHours(0, 0, 0, 0);
  const diff = (day2.getTime() - day1.getTime()) / (1000 * 60 * 60 * 24);

  if (diff >= days) return false;
  return true;
};
